import theme, { ThemeProvider } from '@hixme-ui/theme'
import { clearModal } from '@hixme/modal'
import { ThemeProvider as SureCoAntdProvider } from '@surecompanies/theme'
import { withLDProvider } from 'launchdarkly-react-client-sdk'
import modal from 'modules/modal'
import PropTypes from 'prop-types'
import React from 'react'
import { Provider } from 'react-redux'
import { browserHistory, Router } from 'react-router'
import ActivityLogPopup from '../modules/activity-log/components/ActivityLogPopup'
import { logPageView as activityLogPageView } from '../modules/activity-log/log-page-view'
import appConfig from '../modules/app-config'

import { DesignSystemProvider } from '@surecompanies/react-design-system'
import { defaultFontFamily } from 'design-system/constants'
import tryScroll from 'helpers/tryScroll'
import useFeatureFlags from '../hooks/useFeatureFlags'

function onUpdate(store) {
  return () => {
    store.dispatch(modal.actions.hideModal())
    store.dispatch(clearModal())

    activityLogPageView(store.getState())
    tryScroll()
  }
}

const AppContainer = ({ routes, store }) => {
  const { flags } = useFeatureFlags()

  // Example usage of feature flags:
  if (flags['qle-v-1']) {
    console.info('QLE v1 is enabled!')
  }

  return (
    <Provider store={store}>
      <DesignSystemProvider>
        <ThemeProvider
          theme={{
            ...theme,
            fontFamily: {
              thinnest: defaultFontFamily,
              thinner: defaultFontFamily,
              thin: defaultFontFamily,
              normal: defaultFontFamily,
              bold: defaultFontFamily,
              bolder: defaultFontFamily,
              boldest: defaultFontFamily,
            },
          }}
        >
          <SureCoAntdProvider>
            <div style={{ height: '100%' }}>
              <Router history={browserHistory} onUpdate={onUpdate(store)}>
                {routes}
              </Router>
              <ActivityLogPopup />
            </div>
          </SureCoAntdProvider>
        </ThemeProvider>
      </DesignSystemProvider>
    </Provider>
  )
}

AppContainer.propTypes = {
  routes: PropTypes.object.isRequired,
  store: PropTypes.object.isRequired,
}

// Update the export default to use your environment-specific client ID and a sample context:
export default withLDProvider({
  clientSideID: appConfig.getLaunchDarklyConfig().clientSideID,
  reactOptions: {
    useCamelCaseFlagKeys: false,
  },
})(AppContainer)
